import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Link, NavLink, Outlet } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import { clientAccPDViewPath, managePDViewPath } from "../../../routes/routePaths";
import { navLinkHeaderStylefunc } from "../../../routes/navLinkStylefunc";
import { getAccessTypes } from "../../../hooksAndFunctions/functions/getAccessTypes";
import { useGetSiteCoreCMSData } from "../../../reactQueries/commonRQHooks";

const ProgrammeDescriptorHeader = () => {
  const {
    clientPortalAdminType
  } = getAccessTypes()

  const {
    hasA2Access,
    hasA3Access
  } = clientPortalAdminType

  const {isSuccess: isSuccessOnSiteCoreCMS, error: errorOnSiteCoreCMS, data: resourcesCMSDataFromAPI, isError: isErrorOnSiteCoreCMS, 
    isFetching: isFetchingOnSiteCoreCMS} = useGetSiteCoreCMSData({pagename: "Resources"});

  const [resourcesCMSData, setResourcesCMSData] = useState({
    title: "",
    description: "",
    tabNavigationTitle: "",
    pageContent: {},
  });

  const fetchResourcesCMSData = () =>{
    if(resourcesCMSDataFromAPI && resourcesCMSDataFromAPI.Pages){
      resourcesCMSDataFromAPI.Pages.map((el) => {
       if (el.Key === "ClientResources") {
          const { Title, Description, TabNavigationTitle, Components } = el;
          setResourcesCMSData({ title: Title, description: Description, tabNavigationTitle: TabNavigationTitle, pageContent: Components });
       }
      });
    }
  }

  useEffect(() => {
    fetchResourcesCMSData();
   }, [resourcesCMSDataFromAPI]);

  return (
    <React.Fragment>
      <Box sx={{ width: "100%" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          justifyContent="center"
          alignItems="center"
          divider={<Divider orientation="vertical" flexItem />}
        >
          <Button
            variant="text"
            size="large"
            component={NavLink}
            style={navLinkHeaderStylefunc}
            to={clientAccPDViewPath}
            disabled={
              //!!hasA2Access || hasA3Access // allow A2 
              hasA3Access
            }
          >
            {/* Client Account-Resources */}
            {resourcesCMSData?.pageContent["ClientAccountResourcesList"]?.Title}
          </Button>

          <Button
            variant="text"
            size="large"
            component={NavLink}
            style={navLinkHeaderStylefunc}
            to={managePDViewPath}
            disabled={
              hasA2Access // block A2
            }
          >
            {/* Manage Resource Repo */}
            {resourcesCMSData?.pageContent["ManageResourceRepoList"]?.Title}
          </Button>
        </Stack>
        <Divider sx={{ margin: "10px" }} />
      </Box>
      {/** aquires all child route element components */}
      <Outlet context={resourcesCMSData}/>
    </React.Fragment>

  );
};

export default ProgrammeDescriptorHeader;
